export default "__VITE_ASSET__CYUgFsw4__"